// extracted by mini-css-extract-plugin
module.exports = {"hover":"userAvatar_hover__2K6ST"};